<template>
	<ModalRouting
	:loading="loading"
	:title="tab == 'gallery' ? 'Galeria de evidências da entrega Nº ' + current.document_number : 'Mapa de evidências da entrega Nº ' + current.document_number"
	@close="close">
		<div v-if="loading">
			<div class="loading">
				<i class="fa fa-circle-notch fa-spin"></i>
			</div>
		</div>
        <div class="row">
			<div class="col-xs-12 col-lg-12">
				<div class="evidence-tabs">
					<button class="evidence-tab-item" :class="{ 'enabled': (tab == 'gallery') }" @click="tab = 'gallery'">
						<i class="fas fa-fw fa-list"></i> Galeria
					</button>
					<button class="evidence-tab-item" :class="{ 'enabled': (tab == 'map') }" @click="tab = 'map'">
						<i class="fas fa-fw fa-map"></i> Mapa
					</button>
				</div>
			</div>
		</div>
        <div class="row">
			<div v-if="tab == 'gallery'" class="col-xs-12 col-lg-12">
				<div class="col-xs-12 col-lg-12 evidence-container-itens">
					<div v-for="(item, idx) in Object.values(list)" :key="idx" class="evidence-container-item">
						<div class="evidence-item">
							<div class="evidence-item-media" v-html="item.tag" @click="openGallery(idx)"></div>
						</div>
						<div class="evidence-type">
							<span v-if="item.type == 'image'" ><i class="fas fa-fw fa-camera"></i> Foto</span>
							<span v-else><i class="fas fa-fw fa-video"></i> Vídeo</span>
						</div>
						<div class="evidence-label"><i class="fas fa-fw fa-clock"></i> {{ item.date }}</div>
						<div class="evidence-download">
							<button class="button-download" @click="download(item.src, item.filename)"><i class="fas fa-fw fa-download"></i> Download</button>
						</div>
					</div>
					<LightBox
						:media="media"
						:show-caption="true"
						:show-light-box="false"
						ref="lightbox"
					></LightBox>
				</div>
			</div>
			<div v-if="tab == 'map'" class="col-xs-12">
				<evidence-google-maps
					:delivery="current_data"
					:evidences="current_evidence_list"
					ref="evidence"
				/>
			</div>
		</div>
	</ModalRouting>
</template>

<script>
import Api from "@/lib/Api";

import ModalRouting from "@/components/ModalRouting";
import EvidenceGoogleMaps from "../../components/EvidenceGoogleMaps.vue";
import LightBox from 'vue-it-bigger';
import('vue-it-bigger/dist/vue-it-bigger.min.css');

const loading = require('@/assets/loading.gif');
const no_file = require('@/assets/no_file.png');
const img_ext = ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
//const video_ext = ['mp4'];

export default {
	name: "DeliveryEvidence",

	props: {
		current: {
			type: Object,
			require: true,
		}
	},

	components: {
		ModalRouting,
		EvidenceGoogleMaps,
		LightBox 
	},

	data: function() {
		return {
			loading: false,
			tab: "gallery",
			current_data: this.current,
			current_evidence_list: this.current_evidence_list,
			list: [],
			media: [],
		}
	},

	beforeMount: async function() {
		await this.getEvidenceList();
	},

	methods: {
		getEvidenceList: async function() {
			this.loading = true;
			let res = null;
			
			try {
				res = await Api.post("evidence/get-evidence-list", {
					fk_delivery: this.current.id
				});
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter as evidências.");
				return;
			}

			this.loading = false;

			if (res != null) {
				if (res.error) {
					this.$notification.error(res.data);
					this.close();
					return;
				}

				this.current_evidence_list = res.data;

				this.current_evidence_list.forEach(async (item, index) => {
					if (item.exist_file) {
						item.type = this.getMediaType(item.filename);
						item.date = 'date' in item ? this.getDateAndHourFormated(item.date) : '';
						item.thumb = loading;
						item.src = loading;
						item.tag = '<img title=' + item.date + ' src=' + loading + ' height="200px" />';
						
						if (item.type == "image") {
							this.$set(this.list, item.id, {
								type: item.type,
								filename: item.filename,
								date: item.date,
								thumb: item.thumb,
								src: item.src,
								tag: item.tag,
							});
							this.media.push({
								id: index,
								type: item.type,
								thumb: item.thumb,
								src: item.src,
								caption: item.date,
							});
							this.getThumbnail(item, index);
							this.getFile(item, index);
						} else {
							this.$set(this.list, item.id, {
								type: item.type,
								filename: item.filename,
								date: item.date,
								thumb: item.thumb,
								src: item.src,
								tag: item.tag,
							});
							this.media.push({
								id: index,
								type: item.type,
								thumb: item.thumb,
								sources: [
									{
										src: "#",
										type: "video/mp4",
									},
								],
								caption: item.date,
								width: 800,
								height: 800,
							});
							this.getThumbnail(item, index);
							this.getFile(item, index);
						}
					}
				});
			}
		},

		getThumbnail: async function(item, index) {
			let url = 'delivery/get-evidence?id=' + item.fk_delivery + '&file=thumbnail_' + encodeURIComponent(item.filename.replace(this.getExtension(item.filename), "")) + 'jpg';
			let res = null;

			try {
				res = await Api.blob(url);
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível recuperar o arquivo da evidência.");

				item.thumb = no_file;
				item.tag = '<img title="' + item.date + '" src="' + no_file + '" height="200px" />';
				this.$set(this.list, item.id, {
					type: item.type,
					filename: item.filename,
					date: item.date,
					thumb: item.thumb,
					src: item.src,
					tag: item.tag,
				});
				this.media[index].thumb = item.thumb;
				return;
			}
			
			if (res) {
				item.thumb = res;
				item.tag = '<img title="' + item.date + '" src="' + res + '" height="200px" />';
				this.$set(this.list, item.id, {
					type: item.type,
					filename: item.filename,
					date: item.date,
					thumb: item.thumb,
					src: item.src,
					tag: item.tag,
				});
				this.media[index].thumb = item.thumb;
				return;
			} else {
				item.thumb = no_file;
				item.tag = '<img title="' + item.date + '" src="' + no_file + '" height="200px" />';
				this.$set(this.list, item.id, {
					type: item.type,
					filename: item.filename,
					date: item.date,
					thumb: item.thumb,
					src: item.src,
					tag: item.tag,
				});
				this.media[index].thumb = item.thumb;
			}
		},
		
		getFile: async function(item, index) {
			let url = 'delivery/get-evidence?id=' + item.fk_delivery + '&file=' + encodeURIComponent(item.filename);
			let res = null;

			try {
				res = await Api.blob(url);
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível recuperar o arquivo da evidência.");
				
				item.src = no_file;
				this.$set(this.list, item.id, {
					type: item.type,
					filename: item.filename,
					date: item.date,
					thumb: item.thumb,
					src: item.src,
					tag: item.tag,
				});
				this.media[index].src = item.src;
				
				return;
			}
			
			if (item.type == "image") {
				item.src = res;
				this.$set(this.list, item.id, {
					type: item.type,
					filename: item.filename,
					date: item.date,
					thumb: item.thumb,
					src: item.src,
					tag: item.tag,
				});
				this.media[index].src = item.src;
				return;
			} else {
				item.src = res;
				this.$set(this.list, item.id, {
					type: item.type,
					filename: item.filename,
					date: item.date,
					thumb: item.thumb,
					src: item.src,
					tag: item.tag,
				});
				this.media[index].sources = [
					{
						src: item.src,
						type: "video/mp4",
					},
				];
				return;
			}
		},

		getExtension: function(filename) {
			return filename.split(".").pop().toLowerCase();
		},

		getMediaType: function(filename) {
			let ext = this.getExtension(filename);
			if (img_ext.includes(ext)) {
				return "image";
			} else {
				return "video";
			}
		},

		/**
         * Prepara o arquivo de download
         * @param {File} data objeto de informações
         */
		download(source, filename) {
            if(source, filename) {
                var encodedUri = encodeURI(source);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", this.current_data.document_number + "_" + this.current_data.date + "_" + filename);
                document.body.appendChild(link);
                link.click();
            }
        },

		openInNewTab(url) {
			if (!url) return;
			window.open(url,'_blank');
		},

		openGallery(index) {
			this.$refs.lightbox.showImage(index);
		},

		// Retorna a data e horário formatados
		getDateAndHourFormated: function(data) 
		{
			let date = new Date(data);
			return date.toLocaleString();
		},

		close: function() {
			this.$parent.show_modal_map_evidence = false;
		}
	}
}
</script>

<style scoped>
.loading {
	position: relative;
	height: calc(100vh - 112px);
    width: 100%;
    background: #fff;
    font-size: 80px;
	color: #ddd;
    text-align: center;
    line-height: calc(100vh - 112px);
}

.evidence-tabs {
    border-bottom: 1px solid #eee;
}

.evidence-tab-item {
	margin-top: 10px;
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-left: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.evidence-tab-item.enabled {
	background: #fff;
}

.evidence-container-item {
	float: left;
	width: 200px;
	margin: 15px;
	border-radius: 5px;
	box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
	background-color: #eee;
}

.evidence-item {
	overflow: hidden;
	height: 200px;
	width: 200px;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	cursor: pointer;
}

.evidence-item:hover {
	opacity: 0.6;
}

.evidence-item-media {
    position: relative;
}

.evidence-type {
	font-size: 12px;
	padding: 15px 15px 0px;
}

.evidence-label {
	font-size: 12px;
	padding: 15px 15px;
}

.evidence-download {
	font-size: 12px;
	padding: 0px 15px 15px;
}

.image {
  width: 100px;
  height: 100px;
  background-size: cover;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
  border: 1px solid lightgray;
  object-fit: contain;
}

.button-download {
	background: #222;
	color: #fff;
	font-size: 12px;
	padding: 4px 10px;
	border-radius: 4px;
	text-decoration: none;
	border: none;
}
</style>